module.exports = __webpack_public_path__ + "img/40_37_029_290.a74716b6.jpg";